module.exports = __webpack_public_path__ + "static/kaushik-a0e59e30aa961a0499e05704857ba0cf.jpg";